import { useEffect, useState, useCallback } from 'react';
import * as defaultDarkTheme from '../themes/dark.json';
import localStorageWorker from '../utils/localStorageWorker';

export default () => {
    // @ts-ignore because it's module
    const [theme, setTheme] = useState<any>(defaultDarkTheme.default);

    const setMode = useCallback(
        (mode: any) => {
            localStorageWorker.setToLS('theme', mode);
            setTheme(mode);
        },
        [setTheme],
    );

    useEffect(() => {
        const localTheme = localStorageWorker.getFromLS('theme');
        const allThemes = localStorageWorker.getFromLS('all-themes');
        if (localTheme) {
            const themeName: string = localTheme.name;
            setTheme(allThemes[themeName.toLowerCase().trim()]);
        }
    }, []);

    return [theme, setMode];
};
